import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-materialize";
import Html from "../../../../utils/Html";
import config from "../../../../config";
import API from "../../../../utils/API";

import { useAlluser } from "context/AlluserContext";

export default function ExportSheetModal({
  userData,
  handleEvents,
  isOpen,
  setOpenExportSheet,
  filters,
}) {
  const { inputs, storeInputs } = useAlluser();
  const [itemData, setItemData] = useState({
    data: {},
    status: "",
    err: 0,
    err_msg: "",
  });
  let header = "Export to sheet";
  let content = "";
  let btns = [<div className="header">{header}</div>];
  let modalCSS = {};
  modalCSS.width = "400px";
  // modalCSS.height = "50%";
  modalCSS.maxHeight = "265px";
  useEffect(() => {
    setItemData({
      data: {},
      status: "",
      err: 0,
      err_msg: "",
    });
  }, [isOpen]);
  handleEvents.RadioSelectedDisplayed = {
    OnChange: function (evt) {
      storeInputs({ ...inputs, selectedExportSheet: "displayed" });
    },
  };
  handleEvents.RadioSelectedAll = {
    OnChange: function (evt) {
      storeInputs({ ...inputs, selectedExportSheet: "all" });
    },
  };
  handleEvents.BtnConfirmExportSheet = {
    OnClick: function (evt) {
      setItemData({ status: "inprocess" });
      const mainFunc = async () =>
        await API.post("alluser/export", {
          params: ({
            userID: userData.idu,
            userEmail: userData.emailadd,
            exportType: inputs.selectedExportSheet,
            filters: { ...filters, limit: 0 },
          }),
        });
      mainFunc()
        .then((res) => {
          const decrypt = (res?.data);
          // console.log("alluser export=", decrypt);
          if (decrypt?.status === "success") {
            setItemData(decrypt);
          } else {
            setItemData({
              spreadsheetUrl: "",
              status: "",
              err: 1,
              err_msg: decrypt?.err_msg ?? "",
            });
          }
        })
        .catch((err) => {
          //console.log(infos.tabActive, err);
          setItemData({ spreadsheetUrl: "", status: "", err: 1, err_msg: err });
        });
    },
  };
  if ("err" in itemData && itemData.err === 1) {
    modalCSS.height = "170px";
    btns.push(
      <Button
        flat
        modal="close"
        node="button"
        waves="red"
        className="modal-close"
      >
        <i className="material-icons">close</i>
      </Button>
    );
    content = (
      <div className="text-error">Fetch request error: {itemData.err_msg}</div>
    );
  } else if (itemData.status === "inprocess") {
    content = (
      <div>
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto",
            },
          }}
        />
      </div>
    );
  } else {
    btns.push(
      <Button
        flat
        modal="close"
        node="button"
        waves="red"
        className="modal-close"
      >
        <i className="material-icons">close</i>
      </Button>
    );
    if (itemData?.spreadsheetUrl && itemData?.spreadsheetUrl !== "") {
      modalCSS.maxHeight = "220px";
      content = (
        <div className="modal-content-outer">
          <div key="modal-content-inner" className="modal-content-inner">
            <a
              href={itemData.spreadsheetUrl}
              className="btn-floating waves-effect waves-light"
              style={{ position: "absolute", top: "20px", left: "25px" }}
            >
              <i className="material-icons">check</i>
            </a>
            <div
              style={{
                display: "inline-block",
                marginLeft: "55px",
                fontSize: "18px",
              }}
            >
              <span>Your report has been exported.</span>
              <a
                href={itemData.spreadsheetUrl}
                target="_blank"
                style={{ position: "unset", display: "inline-block" }}
                rel="noreferrer"
              >
                Open the sheet.
              </a>
            </div>
          </div>
        </div>
      );
    } else {
      content = (
        <div className="modal-content-outer">
          <div key="modal-content-inner" className="modal-content-inner">
            <p>
              <label>
                <input
                  className="with-gap"
                  name="radio_displayed"
                  type="radio"
                  checked={
                    inputs.selectedExportSheet === "displayed" ? true : false
                  }
                  onChange={handleEvents.RadioSelectedDisplayed.OnChange}
                />
                <span>Columns as displayed</span>
              </label>
            </p>
            <p>
              <label>
                <input
                  className="with-gap"
                  name="radio_all"
                  type="radio"
                  checked={inputs.selectedExportSheet === "all" ? true : false}
                  onChange={handleEvents.RadioSelectedAll.OnChange}
                />
                <span>All columns</span>
              </label>
            </p>
            <Button
              className=""
              id="btn-confirm-exportsheet"
              node="button"
              waves="light"
              small={true}
              style={{
                width: "100px",
                borderRadius: "20px",
                margin: "0 auto",
                display: "block",
              }}
              onClick={handleEvents.BtnConfirmExportSheet.OnClick}
            >
              Export
            </Button>
          </div>
          <div key="modal-loading" className="modal-loading hide">
            <Html.Preloading
              addon={{
                css: {
                  position: "absolute",
                  top: "0",
                  left: "0",
                  right: "0",
                  bottom: "0",
                  margin: "auto",
                },
              }}
            />
          </div>
        </div>
      );
    }
  }

  return (
    <Modal
      actions={btns}
      bottomSheet={false}
      fixedFooter={false}
      className="modal-user modal-user-footer"
      id="exportsheet-modal"
      open={isOpen}
      options={{
        dismissible: true,
        endingTop: "10%",
        inDuration: 250,
        onCloseEnd: null,
        onCloseStart: handleEvents.BtnExportSheet.OnClose,
        onOpenEnd: null,
        onOpenStart: null,
        opacity: 0.5,
        outDuration: 250,
        preventScrolling: true,
        startingTop: "5%",
      }}
      root={document.getElementById("root")}
      style={modalCSS}
    >
      {content}
    </Modal>
  );
}

